import type { IMarket } from "~/types/event";

import { isConsensusAvailable } from "./isConsensusAvailable";
import { isWithinOneOutcome } from "./isWholeGroupSelected";

export const isConsensusSelection = (
  markets: IMarket[],
  selections: string[]
): boolean =>
  isWithinOneOutcome(markets, selections) &&
  isConsensusAvailable(markets, selections);
